import React from 'react';
import { Star } from 'lucide-react';

const reviews = [
    {
        id: 1,
        name: "Deven Vekariya",
        role: "Director",

        text: "Denial Enterprise delivered our EVCS project with technical precision; their HT/LT connectivity expertise is unmatched for large-scale MNC infrastructure."
    },
    {
        id: 2,
        name: "Dhirubhai Patel",
        role: "Manager, Field Engineer",

        text: "Reliable vendor for substation building and meter upgrades; they maintain a 99% uptime that keeps our facility operations running smoothly."
    },
    {
        id: 3,
        name: "Vishva Vekariya",
        role: "Assistent",

        text: "The team simplified our entire site transition; their 4-step workflow made managing complex electrical upgrades effortless and efficient."
    },
    {
        id: 4,
        name: "Sumit",
        role: "Field Enginerr",
        text: "Denial Enterprise delivered our EVCS project with technical precision; their HT/LT connectivity expertise is unmatched for large-scale MNC infrastructure."
    },
    {
        id: 5,
        name: "Pooja Mishra",
        role: "Finance Manager",
        text: "Denial Enterprise consistently delivers high ROI on our EV infrastructure; their transparent billing for HT/LT connectivity makes project budgeting predictable and efficient."
    },
    {
        id: 6,
        name: "Nikunj Mangroliya",
        role: "Finance Advisor",
        text: "I highly recommend their turnkey services for MNCs seeking long-term value; their precision metering and maintenance programs significantly reduce operational overhead and capital risk."
    }
];

const ReviewGrid = () => {
    return (
        <section className="testimonial review py-10 position-relative bg-light">
            <div className="overlay"></div>
            <div className="container position-relative">
                <div className="testimonial-inner text-center">
                    {/* Section Header */}
                    <div className="section-title w-lg-50 w-md-75 m-auto mb-6">
                        <h6 className="text-uppercase text-success fw-medium mb-2">Client reviews</h6>
                        <h2 className="fw-bold">
                            Client Success Stories: <span className="text-success">Empowering the EV Journey</span>
                        </h2>
                    </div>

                    {/* Review Grid */}
                    <div className="section-body mb-6 text-start">
                        <div className="row gy-4">
                            {reviews.map((review) => (
                                <div key={review.id} className="col-lg-4 col-md-6">
                                    <div className="review-box p-4 p-md-5 bg-white border-dashed border-2 rounded-4 shadow-sm h-100 transition-hover">

                                        <div className="review-info mb-2">
                                            <h6 className="text-dark fw-bold mb-1">{review.name}</h6>
                                            <span className="text-success small fw-semibold">{review.role}</span>
                                        </div>
                                        <div className="review-star mb-3">
                                            <div className="d-flex text-warning">
                                                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" />)}
                                            </div>
                                        </div>
                                        <div className="review-info">
                                            <p className="fw-normal fst-italic lh-base mb-0 text-muted">
                                                "{review.text}"
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Footer Stats */}
                    <div className="section-bottom w-lg-75 m-auto border-top pt-5">
                        <div className="review-bottom d-flex align-items-center justify-content-center text-center flex-column flex-md-row">
                            <div className="d-flex text-warning me-md-3 mb-2 mb-md-0">
                                {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" />)}
                            </div>
                            <p className="mb-0 text-dark">
                                <span className="fw-bold">99.9% Customer Satisfaction</span> based on 50+ reviews of 50+ Completed Projects, and 25+ Happy Customers trust us.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ReviewGrid;